import { render, staticRenderFns } from "./SalesHistory.vue?vue&type=template&id=7c59624e&scoped=true"
import script from "./SalesHistory.vue?vue&type=script&lang=js"
export * from "./SalesHistory.vue?vue&type=script&lang=js"
import style0 from "./SalesHistory.vue?vue&type=style&index=0&id=7c59624e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59624e",
  null
  
)

export default component.exports